import WalletIcon from '@/assets/svg/ui-elements/wallet.svg';
import { Tooltip, Typography } from '@/design-system';
import { theme } from '@/design-system/theme';
import { useWalletAccess } from '@/features/wallet-access/wallet-access-provider';
import { FeatureFlags, useFeatureFlag } from '@/global-hooks/use-feature-flag-enabled';
import { walletSettingsPath } from '@/pages/settings/settings-tab-keys';
import { truncateAddress } from '@/utils/truncate-address';

import { Glyph, Root, ValueSlot } from './WalletChip.styled';

export const WalletChip = () => {
  const enabled = useFeatureFlag(FeatureFlags.CRYPTO_WALLET);
  const address = useWalletAccess().access?.address;

  if (!enabled) {
    return null;
  }

  const shortAddress = address ? truncateAddress(address, 5, 5) : null;

  return (
    <Tooltip title="Wallet" side="bottom">
      <Root
        to={walletSettingsPath}
        aria-label={shortAddress ? `Open wallet ${shortAddress}` : 'Open wallet'}
      >
        <Glyph>
          <WalletIcon aria-hidden="true" />
        </Glyph>
        {shortAddress && (
          <ValueSlot>
            <Typography as="span" variant="body4" color={theme.colors.text.primary} noWrap>
              {shortAddress}
            </Typography>
          </ValueSlot>
        )}
      </Root>
    </Tooltip>
  );
};
